module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedication",
    attrs: {
      "id": "ded"
    }
  }, [_c('div', {
    staticClass: "textbox"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "small01"
  }, [_vm._v("FOR")]), _vm._v(" ELIZABETH OLSEN ALLER"), _c('br'), _c('span', {
    staticClass: "small01"
  }, [_vm._v("AND")]), _vm._v(" FLORENCE BISCEGLIA OLSEN,"), _c('br'), _c('span', {
    staticClass: "small01"
  }, [_vm._v("TWO OF THE BEST COOKS I KNOW")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("and for")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("BEVERLY HEINZLER,"), _c('br'), _vm._v("WHO BELIEVES THAT WOMEN CAN")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41d45fba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781449400187_epub_ded_r1.vue
// module id = 69
// module chunks = 0